import { render } from "./PayslipSidebar.vue?vue&type=template&id=b96531ac"
import script from "./PayslipSidebar.vue?vue&type=script&lang=js"
export * from "./PayslipSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__